import { Button } from '@dixa/lib-shared-habla';

import { getCsidFromAcwNotificationId } from 'components/conversation/utils/acwNotification';
import { useAppNavigate } from 'utils/url/useAppNavigate';

import { HistoricalNotification } from '../../notificationsPage.types';
import { NotificationRow } from '../notificationRow/notificationRow';

type AcwNotificationProps = {
  notification: HistoricalNotification;
};

export const AcwNotification = ({
  notification,
}: AcwNotificationProps): JSX.Element => {
  const navigate = useAppNavigate();

  const csid = getCsidFromAcwNotificationId(notification.id)?.toString();
  const actionButton = csid ? (
    <Button
      variant="secondary"
      onClick={() => {
        navigate({
          path: '/conversation/:csid',
          params: { path: { csid } },
        });
      }}
    >
      Go to wrap-up time conversation
    </Button>
  ) : undefined;

  return <NotificationRow notification={notification} action={actionButton} />;
};
